import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const EmailRedirectView = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const to = searchParams.get('to') ?? '';

  useEffect(() => {
    if (to) window.location.href = `mailto:${to}`;
    const timer = setTimeout(() => navigate('/home', { replace: true }), 300);
    return () => clearTimeout(timer);
  }, [to, navigate]);

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <p className="text-body-2 text-fg-tertiary">Abriendo cliente de correo...</p>
    </div>
  );
};

export default EmailRedirectView;
